import { render, staticRenderFns } from "./ShortInfoSection.vue?vue&type=template&id=5186f3b2&scoped=true&"
import script from "./ShortInfoSection.vue?vue&type=script&lang=js&"
export * from "./ShortInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186f3b2",
  null
  
)

export default component.exports